// extracted by mini-css-extract-plugin
module.exports = {"iconCard":"icon-card_iconCard__FBC8g"};